import { api } from "@/lib/api";

export type NotificationType =
  | "ticket_created"
  | "ticket_assigned"
  | "ticket_updated"
  | "ticket_resolved"
  | "ticket_closed"
  | "ticket_reopened"
  | "note_added"
  | "sla_warning"
  | "sla_breach"
  | "sla_escalation"
  | "mention"
  | "system";

export interface AppNotification {
  id: string;
  type: NotificationType;
  title: string;
  body: string | null;
  entity_type: string | null;
  entity_id: string | null;
  is_read: boolean;
  read_at: string | null;
  created_at: string;
}

export interface NotificationPage {
  items: AppNotification[];
  total: number;
  page: number;
  page_size: number;
  unread_count: number;
}

export function listNotifications(page = 1): Promise<NotificationPage> {
  return api.get<NotificationPage>(`/notifications?page=${page}&page_size=20`);
}

export function unreadCount(): Promise<{ unread_count: number }> {
  return api.get<{ unread_count: number }>("/notifications/unread-count");
}

export function markRead(id: string): Promise<{ message: string }> {
  return api.post<{ message: string }>(`/notifications/${id}/read`);
}

export function markAllRead(): Promise<{ message: string }> {
  return api.post<{ message: string }>("/notifications/read-all");
}
